export enum CONTACT_TYPES {
  CONTACT = "CONTACT",
  PIN_GENERATOR = "PIN_GENERATOR",
}
